import { ScheduleCadenceFields } from './ScheduleCadenceFields';
import { ScheduleDateFields } from './ScheduleDateFields';
import { ScheduleRecipientsFields } from './ScheduleRecipientsFields';
import { UseScheduleFormReturn } from './useScheduleForm';

export interface ScheduleFormFieldsProps {
  viewKey: string;
  scheduleForm: UseScheduleFormReturn;
  disabled: boolean;
  recipientsLabel?: string;
  sendToSelfLabel?: string;
}

/** The cadence, dates and recipients every report schedule is set with. */
export const ScheduleFormFields = ({
  viewKey,
  scheduleForm,
  disabled,
  recipientsLabel,
  sendToSelfLabel
}: ScheduleFormFieldsProps) => (
  <>
    <ScheduleCadenceFields
      viewKey={viewKey}
      cadence={scheduleForm.cadence}
      form={scheduleForm.form}
      savedCadence={scheduleForm.savedCadence}
      disabled={disabled}
      onCadenceChange={scheduleForm.updateCadence}
    />
    <ScheduleDateFields
      viewKey={viewKey}
      startDate={scheduleForm.startDate}
      endDate={scheduleForm.endDate}
      noEndDate={scheduleForm.noEndDate}
      disabled={disabled}
      onStartDateChange={scheduleForm.setStartDate}
      onEndDateChange={scheduleForm.setEndDate}
      onNoEndDateChange={scheduleForm.setNoEndDate}
    />
    <ScheduleRecipientsFields
      viewKey={viewKey}
      recipients={scheduleForm.recipients}
      recipientInput={scheduleForm.recipientInput}
      notAdded={scheduleForm.notAdded}
      sendToSelf={scheduleForm.sendToSelf}
      disabled={disabled}
      onRecipientsChange={scheduleForm.setRecipients}
      onRecipientInputChange={scheduleForm.setRecipientInput}
      onNotAddedChange={scheduleForm.setNotAdded}
      onSendToSelfChange={scheduleForm.setSendToSelf}
      recipientsLabel={recipientsLabel}
      sendToSelfLabel={sendToSelfLabel}
    />
  </>
);
